var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-hidden vh-100 overflow-y-hidden"},[_c('Header',{attrs:{"activeTab":_vm.activeTab}}),_c('Tabs',{attrs:{"parvandehModalState":_vm.parvandehModalState},on:{"getActiveTab":_vm.getActiveTab}}),(_vm.activeTab)?_c('Content',{attrs:{"activeTab":_vm.activeTab,"loading":_vm.loading,"items":_vm.items}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }